<template>
	<section class="container-fluid">
		<div class="offset-xl-3 col-xl-6 offset-md-2 col-md-8">
			<div class="row">
				<div class="col-12">
					<h1>Locations</h1>
				</div>
			</div>
			<div class="row">
				<div class="col-12">
					<div class="row options-bar">
						<button class="add-item btn-equipment" @click="addOpen = true">Add Location <i class="ss-plus ss-glyphish-filled"></i></button>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-12">
					<List :locations="locations" @edit="editLocation" @delete="deleteLocation"/>
				</div>
			</div>
			<Add v-if="addOpen" @close="addOpen = false"/>
			<Edit v-if="editOpen" @close="editOpen = false" :location="selected"/>
			<Delete v-if="deleteOpen" @close="deleteOpen = false" :location="selected"/>
		</div>
	</section>
</template>

<script>
import { mapState } from 'vuex'
import List from '../Locations/List.vue'
import Add from '../Locations/Add.vue'
import Edit from '../Locations/Edit.vue'
import Delete from '../Locations/Delete.vue'

export default { 
	components: {
		List,
		Add,
		Edit,
		Delete
	},
	data() {
		return {
			selected: null,
			deleteOpen: false,
			editOpen: false,
			addOpen: false
		}
	},
	computed : {
		...mapState({
			locations: state => state.locations.list
		})
	},
	methods: {
		deleteLocation(location) {
			this.selected = location
			this.deleteOpen = true
		},
		editLocation(location) {
			this.selected = location
			this.editOpen = true
		}
	},
	mounted() {
		this.$store.commit('app/setLoading', true)
		this.$store.dispatch('locations/getList')
		.then(() => {
			this.$store.commit('app/setLoading', false);
		})
		.catch(err => {
			this.$store.commit('app/setLoading', false);
			this.$store.dispatch('app/addAlert', {
				type: 'error',
				message: 'An Error occurred, please try later',
				timeout: 3000
			})
		})
	}
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Pages/Locations.vue